import { Button, Space } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';

interface BannerOrderingFooterProps {
  isDirty: boolean;
  isLoading: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export const BannerOrderingFooter: FC<BannerOrderingFooterProps> = ({
  isDirty,
  isLoading,
  onSave,
  onCancel,
}) => {
  return (
    <FooterWrapper>
      <Space>
        <Button disabled={!isDirty || isLoading} onClick={onCancel}>
          Cancelar
        </Button>

        <Button
          type='primary'
          loading={isLoading}
          disabled={!isDirty}
          onClick={onSave}
        >
          Salvar ordem
        </Button>
      </Space>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 48px;
  right: 0;
  padding: 16px 48px 16px 0;
  background: #141414;
  border-top: 1px solid #383838;
  display: flex;
  justify-content: flex-end;
`;
